import { render, staticRenderFns } from "./HrBook.vue?vue&type=template&id=b3c310f2&scoped=true"
import script from "./HrBook.vue?vue&type=script&lang=js"
export * from "./HrBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c310f2",
  null
  
)

export default component.exports